var _path, _g, _path2, _g2, _path3, _g3, _path4, _ellipse, _g4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActionErrorUnknown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 146,
    viewBox: "0 0 174 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_524_14422",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 85,
    y: 111,
    width: 29,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.5073 111.733L109.593 111.739L113.015 127.304C111.188 127.276 106.742 127.471 103.575 128.475C99.6168 129.729 99.1708 134.608 96.4655 138.797C94.3013 142.148 88.2392 142.892 85.4787 142.845L89.5073 111.733Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_524_14422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.5073 111.733L109.593 111.739L113.015 127.304C111.188 127.276 106.742 127.471 103.575 128.475C99.6168 129.729 99.1708 134.608 96.4655 138.797C94.3013 142.148 88.2392 142.892 85.4787 142.845L89.5073 111.733Z",
    fill: "#A8ACBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.856 131.117C92.8146 128.613 88.4082 124.552 86.4591 123.374L91.6872 117.193C96.7262 122.848 106.408 134.308 104.821 134.912C102.838 135.667 96.8974 133.621 94.856 131.117Z",
    fill: "#303858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6683 110.856L91.5446 120.036M88.7014 143.263L89.7033 135.078M89.7033 135.078C94.4587 133.666 96.5656 134.568 99.7769 137.83M89.7033 135.078L91.5446 120.036M91.5446 120.036C97.109 120.22 99.1612 118.272 100.829 110.967",
    stroke: "#616987",
    strokeWidth: 1.22915
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_524_14422",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 70,
    width: 170,
    height: 66
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.441 72.6766L67.2588 70.0803L65.5396 75.1735C56.9012 74.9808 35.5624 75.9579 19.3137 81.4082C-0.997195 88.221 -1.74525 104.272 8.52963 112.926C16.7495 119.848 60.4018 126.899 81.2005 129.559L83.5059 109.735L95.1218 109.676L103.229 135.962C115.194 135.016 143.215 130.759 159.575 121.305C180.026 109.486 171.809 91.9019 150.394 85.5374C133.261 80.4459 116.342 78.6696 110.024 78.4179L108.441 72.6766Z",
    fill: "#FF5C3D"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_524_14422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.441 72.6766L67.2588 70.0803L65.5396 75.1735C56.9012 74.9808 35.5624 75.9579 19.3137 81.4082C-0.997195 88.221 -1.74525 104.272 8.52963 112.926C16.7495 119.848 60.4018 126.899 81.2005 129.559L83.5059 109.735L95.1218 109.676L103.229 135.962C115.194 135.016 143.215 130.759 159.575 121.305C180.026 109.486 171.809 91.9019 150.394 85.5374C133.261 80.4459 116.342 78.6696 110.024 78.4179L108.441 72.6766Z",
    fill: "#752467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2528 94.7895L28.6493 95.1928M84.0972 110.125L85.2534 98.7614L73.4244 98.0156M73.4244 98.0156L68.4676 129.197M73.4244 98.0156L28.6493 95.1928M25.6937 91.8395L28.6493 95.1928M88.5439 70.2904L89.7338 91.6543M90.6483 108.075L89.7338 91.6543M89.7338 91.6543C95.5588 91.5817 95.5902 84.1062 95.5262 80.9352C95.475 78.3984 94.9975 73.0431 94.7651 70.6826M95.387 105.47L94.333 99.8616C97.1149 99.7078 100.391 99.5306 103.955 99.3429M153.52 97.3471C152.013 97.2857 148.831 97.3428 144.627 97.4783M151.314 94.6569C149.661 95.3071 146.008 96.7816 144.627 97.4783M144.627 97.4783C134.07 97.8183 117.068 98.6521 103.955 99.3429M103.955 99.3429L114.791 135.372M65.8205 72.1127L110.371 75.7131",
    stroke: "#420134",
    strokeWidth: 1.22915
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_524_14422",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 82,
    y: 102,
    width: 29,
    height: 30
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8565 102.529L84.0448 105.371L82.1301 121.788C83.8572 121.192 87.3019 121.55 90.3279 122.921C93.702 124.449 94.8086 127.277 98.6854 130.413C101.787 132.923 107.779 131.739 110.387 130.833L96.8565 102.529Z",
    fill: "black"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_524_14422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.8565 102.529L84.0448 105.371L82.1301 121.788C83.8572 121.192 87.3019 121.55 90.3279 122.921C93.702 124.449 94.8086 127.277 98.6854 130.413C101.787 132.923 107.779 131.739 110.387 130.833L96.8565 102.529Z",
    fill: "#A8ACBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5794 102.681L97.51 111.053M107.455 132.235L103.95 124.771M103.95 124.771C98.9916 124.912 97.2712 126.426 95.2372 130.527M103.95 124.771L97.51 111.053M97.51 111.053C92.2806 112.964 89.2776 110.275 85.9186 103.553M96.0854 119.501C93.6909 121.463 92.7587 122.938 92.0801 126.462M92.1763 117.319C90.3471 119.4 89.3066 121.225 88.8318 124.322",
    stroke: "#616987",
    strokeWidth: 1.22915
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0318 12.4831C92.1222 16.8611 88.2877 17.3797 83.1922 15.7912C81.7552 17.8127 78.051 22.5637 74.7297 25.3957C71.5536 28.1039 68.579 25.2622 68.3992 22.538C68.3245 21.4071 67.8106 19.7195 67.0936 18.8417C66.0358 17.5468 65.5816 15.6242 67.3816 14.1604C68.2576 13.4481 68.7072 11.9665 68.4407 10.8692C67.9329 8.77812 68.5319 6.19815 71.977 6.23843C72.9196 6.24945 73.7894 5.56653 74.1591 4.69941C75.4308 1.7173 79.5199 0.248829 82.3707 2.73945C82.9048 3.20606 83.6543 3.39607 84.33 3.18071C87.6635 2.11832 89.0251 4.08419 89.431 5.90062C89.5823 6.57772 90.0551 7.16719 90.6722 7.48437C92.0659 8.20078 93.5988 9.75423 93.0318 12.4831Z",
    fill: "#2F3030"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_524_14422",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 5,
    width: 19,
    height: 27
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 81.1894,
    cy: 18.6584,
    rx: 8.85318,
    ry: 13.1533,
    transform: "rotate(-3.67792 81.1894 18.6584)",
    fill: "#C4C4C4"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_524_14422)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 81.1894,
    cy: 18.6584,
    rx: 8.85318,
    ry: 13.1533,
    transform: "rotate(-3.67792 81.1894 18.6584)",
    fill: "#AE5848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6863 18.0428C74.4089 20.4331 72.6963 21.4657 70.6927 21.0859L71.8068 3.41462L85.2671 0.968373C88.3553 4.24671 93.7818 11.4404 90.7825 13.9886C87.0334 17.1738 84.7488 11.2004 82.8623 12.9824C80.9758 14.7643 79.7374 14.3061 77.2527 13.5158C77.8498 18.1155 74.9637 15.6525 74.6863 18.0428Z",
    fill: "#2F3030"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_524_14422",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 35,
    width: 131,
    height: 57
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.7609 44.7293C53.2907 45.863 51.7876 47.0221 50.119 48.154C40.7451 54.5127 19.3254 76.1227 22.7428 86.1029C26.1603 96.0831 45.8247 89.7573 67.7214 77.3264C72.3851 74.6788 76.0357 72.6045 78.8713 70.992L102.9 72.5069C115.07 77.6289 130.13 83.3265 140.408 85.3398C159.612 89.1016 155.028 69.723 136.321 56.6676C135.059 55.7862 133.844 54.9335 132.671 54.1094C116.462 42.7266 108.008 36.7903 86.085 35.8183C67.6375 34.7999 61.5499 39.4942 54.7609 44.7293Z",
    fill: "#01B388"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_524_14422)"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.7609 44.7293C53.2907 45.863 51.7876 47.0221 50.119 48.154C40.7451 54.5127 19.3254 76.1227 22.7428 86.1029C26.1603 96.0831 45.8247 89.7573 67.7214 77.3264C72.3851 74.6788 76.0357 72.6045 78.8713 70.992L102.9 72.5069C115.07 77.6289 130.13 83.3265 140.408 85.3398C159.612 89.1016 155.028 69.723 136.321 56.6676C135.059 55.7862 133.844 54.9335 132.671 54.1094C116.462 42.7266 108.008 36.7903 86.085 35.8183C67.6375 34.7999 61.5499 39.4942 54.7609 44.7293Z",
    fill: "#FF5C3D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9496 56.3042L60.6267 61.4844C61.8839 53.8222 70.1615 51.1772 74.1432 50.8124L71.9496 56.3042Z",
    fill: "#AE5848"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M103.42 73.4193L75.6475 60.4411M139.053 69.1559L84.7299 48.9378M78.1679 72.0912L87.9358 66.4611M75.6475 60.4411L72.1454 58.7798C71.4701 53.6542 75.1475 48.0196 80.4322 47.3382L84.7299 48.9378M75.6475 60.4411C77.5245 54.1881 79.5756 51.7355 84.7299 48.9378",
    stroke: "#DF2D0A",
    strokeWidth: 1.22915,
    strokeLinejoin: "bevel"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4253 50.6952L100.484 54.4084C101.334 52.0867 102.615 47.3995 100.937 47.2233C99.2589 47.0471 93.23 49.4645 90.4253 50.6952Z",
    fill: "#AE5848"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1185 74.5042L72.0373 56.3096",
    stroke: "#DF2D0A",
    strokeWidth: 1.22915,
    strokeLinejoin: "bevel"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4723 33.9177C75.2802 35.442 75.6543 38.0006 77.7482 39.6795M82.6591 41.3205C80.4322 41.2044 78.8515 40.564 77.7482 39.6795M82.6591 41.3205L83.0955 34.3983M82.6591 41.3205C84.8965 41.4371 86.4823 40.8423 87.5872 39.8973M89.8542 33.2409C90.0441 35.092 89.6693 38.1164 87.5872 39.8973M81.5514 33.7731L77.7482 39.6795M85.2861 34.5364L87.5872 39.8973",
    stroke: "#DF2D0A",
    strokeWidth: 1.22915,
    strokeLinejoin: "bevel"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_524_14422",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 99,
    y: 47,
    width: 15,
    height: 17
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M105.784 56.8539C108.441 64.9388 104.691 63.0309 100.095 53.5922C100.051 51.9766 98.593 47.0052 101.463 47.2565C104.332 47.5078 111.326 51.925 112.537 55.7841C114.939 63.439 112.855 64.6892 109.53 57.4419C111.974 64.7216 109.951 67.4971 105.784 56.8539Z",
    fill: "#FAC081"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_524_14422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.784 56.8539C108.441 64.9388 104.691 63.0309 100.095 53.5922C100.051 51.9766 98.593 47.0052 101.463 47.2565C104.332 47.5078 111.326 51.925 112.537 55.7841C114.939 63.439 112.855 64.6892 109.53 57.4419C111.974 64.7216 109.951 67.4971 105.784 56.8539Z",
    fill: "#AE5848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.583 54.4658C106.372 56.363 108.207 62.232 108.294 63.082M108.907 54.7634C109.677 55.938 111.759 61.1597 112.024 62.5254",
    stroke: "#843628",
    strokeWidth: 1.22915,
    strokeLinejoin: "bevel"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionErrorUnknown);
export default __webpack_public_path__ + "static/media/action_error_unknown.114b095c2a6581f3ef04a2ede7d046c5.svg";
export { ForwardRef as ReactComponent };